import Box from '@/components/UI/box/Box';
import styles from './MoreFiltersItems.module.scss';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import IncrementStepperSection from './incrementStepperSection/IncrementStepperSection';
import Divider from '@/components/UI/divider/Divider';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@/components/UI/button/Button';
import FeaturesItemsSection from '../../midTermFeature/featuresList/featuresItemsSection/FeaturesItemsSection';
import { FC, useEffect, useState } from 'react';
import PriceSlider from '../../midTermPriceRange/priceRangeContainer/priceSlider/PriceSlider';
import { fetchNeighbourhoods } from '@/redux/store/actions/search';
import { Control, SubmitHandler, UseFormHandleSubmit, UseFormSetValue } from 'react-hook-form';
import { MoreFiltersData } from '../MidTermMoreFilters';
import { MidTermFeatures } from '../../constants/midTermFeatures';
interface MoreFiltersItemsProps {
  handleClose: () => void;
  handleSubmit: UseFormHandleSubmit<MoreFiltersData>;
  onSubmit: SubmitHandler<MoreFiltersData>;
  handleResetFilter: (e: any) => void;
  control: Control<any>;
  midTermFeatures: MidTermFeatures[];
  handleValue: UseFormSetValue<any>;
}
const MoreFiltersItems: FC<MoreFiltersItemsProps> = ({
  handleClose,
  control,
  handleSubmit,
  onSubmit,
  handleResetFilter,
  midTermFeatures,
  handleValue
}) => {
  const {
    data
  } = useSelector(state => state.neighbourhoodsReducer);
  const [open, setOpen] = useState({
    neighbourhoods: false,
    mainFeatures: false,
    amenities: false
  });
  const dispatch = useDispatch();
  const handleOpen = (name: 'neighbourhoods' | 'mainFeatures' | 'amenities') => {
    setOpen(prev => ({
      ...prev,
      [name]: !open[name]
    }));
  };
  useEffect(() => {
    !data && dispatch(fetchNeighbourhoods());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return <Box className={styles['more-filters-items-container']} data-sentry-element="Box" data-sentry-component="MoreFiltersItems" data-sentry-source-file="MoreFiltersItems.tsx">
      <Box className={styles['more-filters-items-header']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
        <Box onClick={handleClose} className={styles['close-icon-section']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
          <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="MoreFiltersItems.tsx" />
        </Box>
        <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="MoreFiltersItems.tsx">فیلترها</Typography>
      </Box>
      <form id="more-filter-form-hook-form" className={styles['more-filters-form-container']} onSubmit={handleSubmit(onSubmit)}>
        <Box className={styles['more-filters-main-container']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
          <IncrementStepperSection control={control} name="guests" title="تعداد نفرات" min={1} data-sentry-element="IncrementStepperSection" data-sentry-source-file="MoreFiltersItems.tsx" />
          <Divider data-sentry-element="Divider" data-sentry-source-file="MoreFiltersItems.tsx" />
          <IncrementStepperSection control={control} name="bedroom_count" title="تعداد اتاق" data-sentry-element="IncrementStepperSection" data-sentry-source-file="MoreFiltersItems.tsx" />
          <Divider data-sentry-element="Divider" data-sentry-source-file="MoreFiltersItems.tsx" />
          <Box className={styles['price-range-container']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
            <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="MoreFiltersItems.tsx">قیمت ماهانه</Typography>
            <PriceSlider control={control} data-sentry-element="PriceSlider" data-sentry-source-file="MoreFiltersItems.tsx" />
          </Box>
          <Divider data-sentry-element="Divider" data-sentry-source-file="MoreFiltersItems.tsx" />
          {/* <Box className={styles['neighbourhoods-container']}>
            <Typography variant="bodyL_Bold">انتخاب محله</Typography>
            <Box
              className={`${open.neighbourhoods ? styles['open-neighbourhoods'] : styles['close-neighbourhoods']}`}
            >
              {data ? (
                <NeighbourhoodsItems
                  control={control}
                  data={data}
                  handleValue={handleValue}
                />
              ) : (
                <NeighbourhoodsListSkeleton />
              )}
            </Box>
            <Box className={styles['show-more-button-container']}>
              <Button
                format="text"
                size="small"
                endIcon={open.neighbourhoods ? 'arrow-up-1' : 'arrow-down-1'}
                onClick={() => handleOpen('neighbourhoods')}
              >
                {open.neighbourhoods ? 'نمایش کمتر' : 'نمایش بیشتر'}
              </Button>
            </Box>
           </Box> */}
          {/* <Divider /> */}
          <Box className={styles['features-container'] + ' ' + `${open.mainFeatures ? styles['open-features'] : ''}`} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
            <FeaturesItemsSection control={control} item={midTermFeatures[0]} data-sentry-element="FeaturesItemsSection" data-sentry-source-file="MoreFiltersItems.tsx" />
            <Box className={styles['show-more-button-container']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
              <Button format="text" size="small" endIcon={open.mainFeatures ? 'arrow-up-1' : 'arrow-down-1'} onClick={() => handleOpen('mainFeatures')} data-sentry-element="Button" data-sentry-source-file="MoreFiltersItems.tsx">
                {open.mainFeatures ? 'نمایش کمتر' : 'نمایش بیشتر'}
              </Button>
            </Box>
          </Box>
          <Divider data-sentry-element="Divider" data-sentry-source-file="MoreFiltersItems.tsx" />
          <Box className={styles['features-container'] + ' ' + `${open.amenities ? styles['open-features'] : ''}`} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
            <FeaturesItemsSection control={control} item={midTermFeatures[1]} data-sentry-element="FeaturesItemsSection" data-sentry-source-file="MoreFiltersItems.tsx" />
            <Box className={styles['show-more-button-container']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
              <Button format="text" size="small" endIcon={open.amenities ? 'arrow-up-1' : 'arrow-down-1'} onClick={() => handleOpen('amenities')} data-sentry-element="Button" data-sentry-source-file="MoreFiltersItems.tsx">
                {open.amenities ? 'نمایش کمتر' : 'نمایش بیشتر'}
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className={styles['action-footer']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersItems.tsx">
          <Button format="outlined" onClick={handleResetFilter} data-sentry-element="Button" data-sentry-source-file="MoreFiltersItems.tsx">
            پاک کردن{' '}
          </Button>

          <Button format="primary" size="medium" type="submit" data-sentry-element="Button" data-sentry-source-file="MoreFiltersItems.tsx">
            اعمال فیلتر
          </Button>
        </Box>
      </form>
    </Box>;
};
export default MoreFiltersItems;